import { currencyFormat, stableSort, getSorting } from '../../../Functions';
export function BUExcel(XLSX, data) {
  // console.log('data', data)
  // var origin = GetUniqueOrigin(data.voyageBranches);
  // var destination = GetUniqueDestination(data.voyageBranches);
  var routes = data.voyageBranches.split(" - ");

  var destinationOnly = [];
  for (let x = 1; x < routes.length; x++) {
    destinationOnly.push(routes[x])
  }
  destinationOnly = destinationOnly.sort();
  // console.log('destinationOnly', destinationOnly);

  var DestinationData = [];
  destinationOnly.forEach(element => {
    let WB = [];
    data.wayBIll.forEach(ele => {
      if(element === ele.destination){
        WB.push(ele);
      }
    });
    DestinationData.push({
      destinationHeader: element,
      waybill: WB
    })
  });

  // console.log('DestinationData', DestinationData)

  var wb = XLSX.utils.book_new();

  // Header
  var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

  XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J:"OCEAN TRANSPORT GROUP OF COMPANIES INC." } ], { header: [], skipHeader: true, origin: -1 } );
  XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J:"VESSEL BUILD-UP REPORT" }], { header: [], skipHeader: true, origin: -1 } );
  // XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J:origin[0] + " – " + destination.join(" – ") } ], { header: [], skipHeader: true, origin: -1 } );
  XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "(" + data.voyageNum + ") " + data.voyageBranches } ], { header: [], skipHeader: true, origin: -1 } );
  
  XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 } );

  XLSX.utils.sheet_add_json(ws, [{ A: "Total TEUs: " + data.wayBIll.length }], { header: [], skipHeader: true, origin: -1 });

  XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 } );

  ws["!merges"] = [{ s: { r: 6, c: 0 }, e: { r: 6, c: 20 } }];

  XLSX.utils.sheet_add_json(ws, [
      {
        A: "DATE OF GROUNDING",
        B: "CY",
        C: "BOOKING REF",
        D: "WAYBILL",
        // E: "OLD WAYBILL",
        F: "SHIPPER",
        G: "SHIPPER PREFERRED NAME",
        H: "CONSIGNEE",
        I: "CONSIGNEE PREFERRED NAME",
        J: "CARGO",
        K: "CONTAINER VAN NO",
        L: "SEAL NO",
        M: "TRUCKING",
        N: "PLATE NO",
        O: "DRIVER",
        P: "WEIGHT",
        Q: "SIZE",
        R: "MODE OF DELIVERY",
        S: "MODE OF PAYMENT",
        T: "CARGO TYPE",
        U: "VALUE",
        V: "WITH PERMIT",
        W: "LOAD LIST",
        X: "REMARK"
      }
    ], { header: [], skipHeader: true, origin: -1 } );
    // 
    stableSort(data.wayBIll, getSorting('asc', 'wayBillRef')).forEach(element => {
    let FinalRemark = '';
    if(element.remarks && element.remarks !== ""){
      if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
        if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING, ' + element.remarks; }
        else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; } 
        else { FinalRemark = 'GROUNDING, ' + element.remarks; }
      } else {
        if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO, ' + element.remarks; }
        else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; }
        else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO, ' + element.remarks; } 
        else { FinalRemark = 'GROUNDING, ' + element.remarks; }
      }
    } else {
      if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
        if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING'; }
        else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; } 
        else { FinalRemark = 'GROUNDING'; }
      } else {
        if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO'; }
        else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; }
        else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO'; } 
        else { FinalRemark = 'GROUNDING'; }
      }
    }
    XLSX.utils.sheet_add_json(ws, [
        {
          A: element.dateGrounded ? element.dateGrounded : "",
          B: element.cyName ? element.cyName : element.cy ? element.cy : "",
          C: element.bookingRef,
          D: element.wayBillRef,
          // E: element.oldWaybillRef,
          F: element.shipper,
          G: element.shipperPreferedName,
          H: element.consignee,
          I: element.consigneePreferedName,
          J: element.goods,
          K: element.vanNumber,
          L: element.sealNum,
          M: element.truckerName,
          N: element.plateNum,
          O: element.driver,
          P: element.cargoWeight,
          Q: element.size,
          R: element.modeOfDelivery,
          S: element.modeOfPayment,
          T: element.cargoType,
          U: element.declaredValue > 0 ? currencyFormat(element.declaredValue) : '0',
          V: element.isWithPermit ? "Yes" : "No",
          W: element.waybillStatus !== "Draft" ? "Yes" : "No",
          X: FinalRemark,
        }
      ], { header: [], skipHeader: true, origin: -1 } ); 
  });

  var wscols = [
    { wch: 20 }, // CY-In
    { wch: 16 }, // CY
    { wch: 12 }, // Booking ref
    { wch: 15 }, // Waybill
    // { wch: 15 }, // Old Waybill
    { wch: 30 }, // Shipper
    { wch: 30 }, // Shipper Preferred Name
    { wch: 30 }, // Consignee
    { wch: 30 }, // Consignee Preferred Name
    { wch: 20 }, // Goods
    { wch: 17 }, // Van Number
    { wch: 12 }, // Seal Number
    { wch: 30 }, // Trucker
    { wch: 10 }, // Plate no
    { wch: 15 }, // Driver
    { wch: 7 }, // Weight
    { wch: 5 }, // Size
    { wch: 17 }, // Mode of Delivery
    { wch: 17 }, // Mode of Payment
    { wch: 11 }, // Cargo Type
    { wch: 15 }, // Declared Value
    { wch: 11 }, // With Permit
    { wch: 8 }, // Load List
    { wch: 35 }, // Remarks
  ];

  ws["!cols"] = wscols;

  XLSX.utils.book_append_sheet(wb, ws, "ALL");

  DestinationData.forEach(element => {
    // Header
    var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

    XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J:"OCEAN TRANSPORT GROUP OF COMPANIES INC." } ], { header: [], skipHeader: true, origin: -1 } );
    XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J:"VESSEL BUILD-UP REPORT" }], { header: [], skipHeader: true, origin: -1 } );
    XLSX.utils.sheet_add_json(ws, [ { A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "(" + data.voyageNum + ") " + data.voyageBranches } ], { header: [], skipHeader: true, origin: -1 } );
    
    XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 } );

    XLSX.utils.sheet_add_json(ws, [{ A: "Total TEUs: " + element.waybill.length }], { header: [], skipHeader: true, origin: -1 });

    XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 } );

    ws["!merges"] = [{ s: { r: 6, c: 0 }, e: { r: 6, c: 20 } }];

    XLSX.utils.sheet_add_json(ws, [
        {
          A: "DATE OF GROUNDING",
          B: "CY",
          C: "BOOKING REF",
          D: "WAYBILL",
          // E: "OLD WAYBILL",
          F: "SHIPPER",
          G: "SHIPPER PREFERRED NAME",
          H: "CONSIGNEE",
          I: "CONSIGNEE PREFERRED NAME",
          J: "CARGO",
          K: "CONTAINER VAN NO.",
          L: "SEAL NO.",
          M: "TRUCKING",
          N: "PLATE NO.",
          O: "DRIVER",
          P: "WEIGHT",
          Q: "SIZE",
          R: "MODE OF DELIVERY",
          S: "MODE OF PAYMENT",
          T: "CARGO TYPE",
          U: "VALUE",
          V: "WITH PERMIT",
          W: "LOAD LIST",
          X: "REMARK"
        }
      ], { header: [], skipHeader: true, origin: -1 } );

    stableSort(element.waybill, getSorting('asc', 'wayBillRef')).forEach(element => {
      let FinalRemark = '';
      if(element.remarks && element.remarks !== ""){
        if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
          if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING, ' + element.remarks; }
          else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; } 
          else { FinalRemark = 'GROUNDING, ' + element.remarks; }
        } else {
          if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO, ' + element.remarks; }
          else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; }
          else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO, ' + element.remarks; } 
          else { FinalRemark = 'GROUNDING, ' + element.remarks; }
        }
      } else {
        if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
          if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING'; }
          else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; } 
          else { FinalRemark = 'GROUNDING'; }
        } else {
          if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO'; }
          else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; }
          else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO'; } 
          else { FinalRemark = 'GROUNDING'; }
        }
      }
      XLSX.utils.sheet_add_json(ws, [
          {
            A: element.dateGrounded ? element.dateGrounded : "",
            B: element.cyName ? element.cyName : element.cy ? element.cy : "",
            C: element.bookingRef,
            D: element.wayBillRef,
            // E: element.oldWaybillRef,
            F: element.shipper,
            G: element.shipperPreferedName,
            H: element.consignee,
            I: element.consigneePreferedName,
            J: element.goods,
            K: element.vanNumber,
            L: element.sealNum,
            M: element.truckerName,
            N: element.plateNum,
            O: element.driver,
            P: element.cargoWeight,
            Q: element.size,
            R: element.modeOfDelivery,
            S: element.modeOfPayment,
            T: element.cargoType,
            U: element.declaredValue > 0 ? currencyFormat(element.declaredValue) : '0',
            V: element.isWithPermit ? "Yes" : "No",
            W: element.waybillStatus !== "Draft" ? "Yes" : "No",
            X: FinalRemark,
          }
        ], { header: [], skipHeader: true, origin: -1 } ); 
    });

    var wscols = [
      { wch: 20 }, // CY-In
      { wch: 16 }, // CY
      { wch: 12 }, // Booking ref
      { wch: 15 }, // Waybill
      // { wch: 15 }, // Old Waybill
      { wch: 30 }, // Shipper
      { wch: 30 }, // Shipper Preferred Name
      { wch: 30 }, // Consignee
      { wch: 30 }, // Consignee Preferred Name
      { wch: 20 }, // Goods
      { wch: 17 }, // Van Number
      { wch: 12 }, // Seal Number
      { wch: 30 }, // Trucker
      { wch: 10 }, // Plate no
      { wch: 15 }, // Driver
      { wch: 7 }, // Weight
      { wch: 5 }, // Size
      { wch: 17 }, // Mode of Delivery
      { wch: 17 }, // Mode of Payment
      { wch: 11 }, // Cargo Type
      { wch: 15 }, // Declared Value
      { wch: 11 }, // With Permit
      { wch: 8 }, // Load List
      { wch: 35 }, // Remarks
    ];

    ws["!cols"] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, element.destinationHeader);
  });

  XLSX.writeFile(wb, "Buildup.xlsx");
}